// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3yvZU","validationTips":"StatementDescriptor_validationTips__1blRc"};